<template>
  <div class="heart-sound-check">
    <md-chip class="md-primary">If heart sound was checked</md-chip>
  </div>
</template>

<script>
export default {
  name: 'heart-sound-assessed-check',
  components: {},
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        check: {
        },
      },
    };
  },
  created() {
    this.state.check = {
      ...this.state.check,
      ...(this.getData(this.ikey) || {}),
    };
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'HEART_SOUND_ASSESSED',
        operator: 'EQUAL',
        value: true,
        spot: 0,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.heart-sound-check {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
